export class DateFormatModel {
  dateFormat: string;
  timeZone: string;
  primeFormat: string;
}
